import { DataBean } from "../DataBean";

export class KpiMeasurementCatalog extends DataBean {

    public async getKpiMeasurementCatalog(idKpi: any, from: any, upto: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getKpiMeasurementCatalog_Number_java.util.Date_java.util.Date_Number_Number", [idKpi, from, upto, page, recordsPerPage]);
    }
    public async getKpiEmployeeMeasurementCatalog(idKpiEmployeeMeasurement: any, idAccount: any, idLnFunctionalID: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getKpiEmployeeMeasurementCatalog_Number_Number_Number_Number_Number", [idKpiEmployeeMeasurement, idAccount, idLnFunctionalID, page, recordsPerPage]);
    }
    public async deleteKpiEmployeeMeasurement(idKpiEmployeeMeasurement: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteKpiEmployeeMeasurement_Number", [idKpiEmployeeMeasurement]);
    }
}
